import camelToSnake from "@/plugins/lodash/camelToSnake";
import { isPresent } from "@/utils/type-check";
import { mutations as types } from "./types";

const mutations = {
  [types.ANALYTIC_ATTACH]: (state, attach) => {
    state.attach = attach;
  },
  [types.ANALYTIC_ADD_VARIANTS_ATTACH]: (state, variants) => {
    if (state.attach) {
      state.attach.pages.push(...variants);
      const len = state.attach.pages.length;
      const avg = 1/len;
      state.attach.pages.forEach((item) => {
        item.percent = avg;
      })
    }
  },
  [types.ANALYTIC_UPDATE_PERCENT_ATTACH]: (state, { id, variants }) => {
    if (state.attach && state.attach.id == id) {
      variants.forEach((item) => {
        const found = state.attach.pages.find(x => x.g_id == item.g_id);
        if (found) {
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              const value = item[key];
              found[key] = value;
            }
          }
        }
      })
    }
  },
  [types.ANALYTIC_FETCH_NEW]: (state, { list, total }) => {
    state.campaigns.list = list;
    state.campaigns.total = total;
  },
  [types.ANALYTIC_FETCH]: (state, list) => {
    state.campaigns.list = list;
  },
  [types.ANALYTIC_APPEND](state, campaign) {
    // new methods
    let index = state.campaigns.list.findIndex(item => item.id == campaign.id);
    if (index > -1) state.campaigns.list.splice(index, 1, campaign);
    else {
      state.campaigns.list.push(campaign);
    }
  },
  [types.ANALYTIC_UPDATE_CAMPAIGN](state, { campaign, attributes, data }) {
    let idx = state.campaigns.list.findIndex(_item =>  _item.id == campaign.id);
    
    const source = {
      ...campaign,
    };
    Object.keys(data).forEach(key => {
      if (isPresent(data[key])) {
        source[camelToSnake(key)] = data[key];
      }
    })
    if (idx > -1) {
      let item = { ...state.campaigns.list[idx] };
      attributes.forEach(key => {
        const snake = camelToSnake(key);
        item[snake] = source[snake];
      });
      state.campaigns.list.splice(idx, 1, item);
    }
    if (state.attach && state.attach == campaign.id) {
      attributes.forEach(key => {
        const snake = camelToSnake(key);
        state.attach[snake] = source[snake];
      });
    }
  },
  [types.ANALYTIC_DELETE_CAMPAIGN](state, id) {
    let ind = state.campaigns.list.findIndex(x => x.id == id);
    if (ind > -1) {
      state.campaigns.list.splice(ind, 1);
    }
  },
  [types.ANALYTIC_UPDATE_CAMPAIGN_STATUS](state, { id, status }) {
    let ind = state.campaigns.list.findIndex(x => x.id == id);
    if (ind > -1) {
      let item = JSON.parse(JSON.stringify(state.campaigns.list[ind]));
      item.status = status;
      item.updated_at = new Date().toISOString();
      if (status == "running") {
        item.started_at = item.updated_at;
      }
      state.campaigns.list.splice(ind, 1, item);
    }
    // check attach
    if (state.attach && state.attach.id == id) {
      state.attach.status = status;
      state.attach.updated_at = new Date().toISOString();
      if (status == "running") {
        state.attach.started_at = state.attach.updated_at;
      }
    }
  },
  [types.ANALYTIC_UPDATE_CAMPAIGN_INDICATING](state, { id, status }) {
    let ind = state.campaigns.list.findIndex(x => x.id == id);
    if (ind > -1) {
      let item = JSON.parse(JSON.stringify(state.campaigns.list[ind]));
      if (status) {
        item.indicating = status;
      } else {
        delete item.indicating;
      }
      item.updated_at = new Date().toISOString();
      state.campaigns.list.splice(ind, 1, item);
    }
  },
  [types.ANALYTIC_DELETE_CAMPAIGN_VARIANT](state, { campaignID, variantID }) {
    let ind = state.campaigns.list.findIndex(x => x.id == campaignID);
    if (ind > -1) {
      const c = state.campaigns.list[ind];
      if (c.pages && c.pages.length) {
        const vIndex = c.pages.findIndex(x => x.g_id == variantID);
        if (vIndex > -1) {
          c.pages.splice(vIndex, 1);
        }
        state.campaigns.list.splice(ind, 1, c);
      }
    }
    if (state.attach && state.attach.id == campaignID) {
      const c = state.attach;
      if (c.pages && c.pages.length) {
        const vIndex = c.pages.findIndex(x => x.g_id == variantID);
        if (vIndex > -1) {
          c.pages.splice(vIndex, 1);
        }
      }
    }
  },
  [types.ANALYTIC_UPDATE_CAMPAIGN_VARIANT](state, { campaignID, variantID, data }) {
    const newISO = (new Date()).toISOString();
    let ind = state.campaigns.list.findIndex(x => x.id == campaignID);
    if (ind > -1) {
      const c = state.campaigns.list[ind];
      if (c.pages && c.pages.length) {
        const vIndex = c.pages.findIndex(x => x.g_id == variantID);
        if (vIndex > -1) {
          const item = c.pages[vIndex];
          for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              const value = data[key];
              item[camelToSnake(key)] = value;
            }
          }
          item.updated_at = newISO;
          c.pages.splice(vIndex, 1, item);
        }
        c.updated_at = newISO;
        state.campaigns.list.splice(ind, 1, c);
      }
    }

    if (state.attach && state.attach.id == campaignID) {
      const c = state.attach;
      if (c.pages && c.pages.length) {
        const vIndex = c.pages.findIndex(x => x.g_id == variantID);
        if (vIndex > -1) {
          const item = c.pages[vIndex];
          for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
              const value = data[key];
              item[camelToSnake(key)] = value;
            }
          }
          item.updated_at = newISO;
          c.pages.splice(vIndex, 1, item);
        }
      }
      c.updated_at = newISO;
    }
  },
  [types.ANALYTIC_FETCH_ACCOUNTS]: (state, list) => {
    state.accounts.list = list.sort((item1, item2) => {
      if (item1.name > item2.name) {
        return 1;
      }
      if (item1.name < item2.name) {
        return -1;
      }
      return 0;
    });
    state.accounts.fetched = true;
  },
};

export default mutations;
